import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})

export class MomentSetService {

  constructor() { }

  setDefaultTimeZone(timeZone: string) {
    moment.tz.setDefault(timeZone);
  }

  convertDateServer(fecha: Date) : Date {
    //Convertir la fecha al huso horario de la maquina
    let fechaFormateada = null;
    if (fecha != null)
    {
      // fechaFormateada = new Date(moment(fecha).startOf('day').format('YYYY-MM-DD HH:mm')); no usar porque le saca la hora
      fechaFormateada = new Date(moment(fecha).format('YYYY-MM-DD HH:mm'));
    }    

    return fechaFormateada;
  }

  saveDateServer(fecha: Date, conHora: boolean) : string {
    //Le saca hora y zona horaria para mandar a grabar y q se ponga la del server
    let fechaFormateada = '';
    if (fecha != null && moment.isDate(fecha))
    {
      let year = fecha.getFullYear();
      let month = String(fecha.getMonth() + 1).padStart(2, '0'); // Agrega un cero al mes si es necesario
      let day = String(fecha.getDate()).padStart(2, '0');
      if (conHora)
      {
        let hour = String(fecha.getHours()).padStart(2, '0');
        let minutes = String(fecha.getMinutes()).padStart(2, '0');
        fechaFormateada = moment( `${year}-${month}-${day} ${hour}:${minutes}`).format('YYYY-MM-DD HH:mm:SS');
      }
      else
      {
        fechaFormateada = moment( `${year}-${month}-${day}`).format('YYYY-MM-DD');
      }      
    }

    return fechaFormateada;
  }
}